import React from 'react'
import { observer } from 'mobx-react'
import TeamViewModel, { Tab } from './TeamViewModel'
import { TabBar, useTabControllerForTabBar } from 'components/TabBar'
import TeamDetails from './TeamDetails'
import TeamMembers from './TeamMembers'
import { useDocumentTitle } from 'hooks/document-title'
import { match } from 'utils/pattern-match-util'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from 'components/StickyViewHeader'
import AvatarSelector from 'components/AvatarSelector'
import { ViewHeading } from 'components/ViewHeading'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import TeamPayments from './TeamPayments'
import ScrollView from 'components/ScrollView'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: TeamViewModel
}

export default observer(function Team({ vm }: Props) {
  useDocumentTitle(`${vm.team.name} — Teams`)
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)

  return (
    <ScrollView ref={scrollRef}>
      <StickyViewHeader
        scrollOffset={scrollOffset}
        tabBar={
          <TabBar align="left">{useTabControllerForTabBar(vm.tabs)}</TabBar>
        }
      >
        <StickyViewHeaderMain>
          <ViewHeading
            visual={
              <AvatarSelector
                size={48}
                isUploading={vm.uploadPicture.pending}
                onSelectNewFile={vm.uploadPicture}
                subject={{
                  avatar: vm.team.avatar,
                  displayName: vm.team.name,
                }}
              />
            }
            primaryText="Teams"
            secondaryText={vm.team.name}
          />
        </StickyViewHeaderMain>
      </StickyViewHeader>

      {match(vm.tabs.current.tab, {
        [Tab.Details]: () => <TeamDetails vm={vm.teamDetailsVM} />,
        [Tab.PaymentMethods]: () => <TeamPayments vm={vm.teamPaymentsVM} />,
        [Tab.Members]: () => <TeamMembers vm={vm.teamMembersVM} />,
      })}
    </ScrollView>
  )
})
